import {
  CLICK_SAVE_ACTIVATE_POLICY_NOW,
  CLICK_SAVE_SCHEDULE_POLICY,
  CLICK_EDIT_ACTIVATE_POLICY_NOW,
  CLICK_EDIT_SCHEDULE_POLICY,
  CLICK_DELETE_SCHEDULE_POLICY,
  CLICK_EDIT_REORDER_POLICY_NOW,
  CLICK_EDIT_SCHEDULE_POLICY_REORDER,
} from '@src/utils/sensor/track';
import { track } from '@utils';
import { formModes } from '@store/policies/schedule/formReducer';
import { actOptions } from '@store/policies/schedule/utils';

export function trackModalActions(mode, activationState) {
  if (mode === formModes.new) {
    if (activationState === actOptions.now) {
      track({ event: CLICK_SAVE_ACTIVATE_POLICY_NOW });
    } else {
      track({ event: CLICK_SAVE_SCHEDULE_POLICY });
    }
  } else if (mode === formModes.edit) {
    switch (activationState) {
      case actOptions.now:
        track({ event: CLICK_EDIT_ACTIVATE_POLICY_NOW });
        break;
      case actOptions.schedule:
        track({ event: CLICK_EDIT_SCHEDULE_POLICY });
        break;

      default:
        break;
    }
  } else if (mode === formModes.delete) {
    track({ event: CLICK_DELETE_SCHEDULE_POLICY });
  }
}
